// extracted by mini-css-extract-plugin
module.exports = {"toast-container":"style_toast-container__v0FG_","red":"style_red__1SZq9"};